<div class="row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{TR "Support"}}</h4>
	</div>
</div>

<div class="card-box clearfix">
	<div class="row">
		<div class="col-md-6">
			<div class="p-20 p-t-0">
				<div class="faq-box">
				<h4 data-wow-delay=".1s" class="question">What is Lorem Ipsum?</h4>
				<p class="answer">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
				</div>
				<div class="faq-box">
				<h4 class="question">Why use Lorem Ipsum?</h4>
				<p class="answer">Lorem ipsum dolor sit amet, in mea nonumes dissentias dissentiunt, pro te solet oratio iriure. Cu sit consetetur moderatius intellegam, ius decore accusamus te. Ne primis suavitate disputando nam. Mutat convenirete.</p>
				</div>
				<div class="faq-box">
				<h4 class="question">How many variations exist?</h4>
				<p class="answer">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
				</div>
				<div class="faq-box">
				<h4 class="question">What is Lorem Ipsum?</h4>
				<p class="answer">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
				</div>
			</div>
		</div>
		{{!-- /col-md-5  --}}

		<div class="col-md-6">
			<div class="p-20 p-t-0">
				<div class="faq-box">
				<h4 class="question">Is safe use Lorem Ipsum?</h4>
				<p class="answer">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
				</div>
				<div class="faq-box">
				<h4 class="question">When can be used?</h4>
				<p class="answer">Lorem ipsum dolor sit amet, in mea nonumes dissentias dissentiunt, pro te solet oratio iriure. Cu sit consetetur moderatius intellegam, ius decore accusamus te. Ne primis suavitate disputando nam. Mutat convenirete.</p>
				</div>
				<div class="faq-box">
				<h4 class="question">License &amp; Copyright</h4>
				<p class="answer">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
				</div>
				<div class="faq-box">
				<h4 class="question">Is safe use Lorem Ipsum?</h4>
				<p class="answer">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
				</div>
			</div>
		</div>
		{{!-- /col-md-5 --}}
	</div>
</div>
